// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useState } from 'react'
import './HeaderLogo.scss'


const HeaderLogo: React.FC<{logo?: string, title: string}> = ({
    logo,
    title
}) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  return (
    <div className="header-logo" style={{visibility: (!!loaded) ? "visible" : "hidden"}}>
      <img
        alt="Web Identity Logo"
        onLoad={() => setLoaded(true)}
        src={logo}
      />
      <h2>{title}</h2>
    </div>
  )
}

export default HeaderLogo